import { useCallback, useEffect, useState } from 'react';
import type { MinimizableModalView } from '@atlassian/jira-minimizable-modal/src/types.tsx';
import { USER_GIC_POSITIONING_SPOTLIGHT } from '../../common/constants';
import { useUserPreferences } from '../../services/user-preferences';

export const useChangerSpotlight = (minimizableModalView?: MinimizableModalView) => {
	const [allowShowingChangerSpotlight, setAllowShowingChangerSpotlight] = useState(false);
	const [userPreferenceSpotlight, setUserPreferences] = useUserPreferences(
		USER_GIC_POSITIONING_SPOTLIGHT,
		false,
	);
	const hasSeenGicPositioningSpotlight = userPreferenceSpotlight;

	const shouldShowChangerSpotlight =
		!hasSeenGicPositioningSpotlight && allowShowingChangerSpotlight;

	const onCloseChangerSpotlight = useCallback(() => {
		if (!hasSeenGicPositioningSpotlight) {
			setAllowShowingChangerSpotlight(false);
			setUserPreferences(true);
		}
	}, [setAllowShowingChangerSpotlight, hasSeenGicPositioningSpotlight, setUserPreferences]);

	const isModalView = minimizableModalView === 'modal';

	useEffect(() => {
		if (!isModalView && shouldShowChangerSpotlight) {
			onCloseChangerSpotlight();
		}
	}, [onCloseChangerSpotlight, isModalView, shouldShowChangerSpotlight]);

	const onOpenSpotlight = () => {
		if (isModalView) setAllowShowingChangerSpotlight(true);
	};

	const onCloseSpotlight = () => {
		if (isModalView) onCloseChangerSpotlight();
	};

	return {
		shouldShowChangerSpotlight,
		onOpenSpotlight,
		onCloseSpotlight,
	};
};
